module.exports = __webpack_public_path__ + "img/trains.0f91bf81.svg";